/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { useDispatch } from "react-redux";

import { useLocation, useNavigate, useParams } from "react-router-dom";

import { CATEGORY_ADD, CATEGORY_DELETE, CATEGORY_LIST, CATEGORY_STATUS_CHANGE, CATEGORY_UPDATE } from "../../../../repository/categroyRepo";

const useCategory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [spinner, setSpinner] = useState(false);
  const [controller, setController] = useState({ page: 1, rowsPerPage: 10 });
   const [totalCount, setTotalCount] = useState(0);
  const [categoryList, setCategoryList] = useState([]);
  const [formError, setFormError] = useState({})
  const { id } = useParams(); // Get ID from URL params
  const location = useLocation(); // Get data from navigation state
  const isEditMode = Boolean(id);

  const [filter, setFilter] = useState({
  search: "",
  isDeleted: false, // default to Active
});

  const [openModal, setOpenModal] = useState({
    addCategory: false,
    editCategory: false,
    delete: false,
    data: null,
  });


     const [formDataCategory, setFormDataCategory] = useState({
        name: "",
  })



    const handleOpenModal = (type, data = null) => {
    setOpenModal((prev) => ({
      ...prev,
      addCategory: type === "add",
      editCategory: type === "edit",
      delete: type === "delete",
      data: data || null,
    }));

   if (type === "edit" && data) {
  setFormDataCategory({
    name: data.name || "",
    _id: data._id || "",
  });
}
  };

const handleCloseModal = () => {
    setOpenModal({
      addCategory: false,
      editCategory: false,
      delete: false,
      data: null,
    });
    setFormError({});
    setFormDataCategory({})
  };

    const isValid = () => {
    const errorObj = {};
    const {name} = formDataCategory;
    if (!name) errorObj["name"] = "Name is required";
    setFormError(errorObj);
    return Object.keys(errorObj).length === 0;
  };




  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormDataCategory((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    setFormError((prev) => ({
      ...prev,
      [name]: "",
    }));
  };


      const handlePagination = (obj) => {
        setController(obj);
    };


    // Initial load - for list page
  useEffect(() => {
    if (!isEditMode) {
      categoryListAPI();
    }

;
  }, []);


    // Trigger API call when pagination changes - for list page
    useEffect(() => {
    if (!isEditMode) {
      categoryListAPI();
    }
  }, [controller.page, controller.rowsPerPage]);


  const handleSearchChange = (e) => {
  setFilter((prev) => ({
    ...prev,
    search: e.target.value,
  }));
};


const handleStatusChange = (value) => {
  setFilter((prev) => {
    // if Active (value === 'false') selected, then add isActive: true
    if (value === "false") {
      return { ...prev, isDeleted: value, isActive: true };
    }

    // for All or Deleted, remove isActive completely
    const { isActive, ...rest } = prev;
    return { ...rest, isDeleted: value };
  });
};

const handleApplyFilter = () => {
  // reset to first page
  setController((prev) => ({ ...prev, page: 1 }));

  // use latest filter and page=1
  categoryListAPI({ ...filter, page: 1 });
};


const handleResetFilter = () => {
  const newFilter = { search: "", isDeleted: false, isActive: false };
  setFilter(newFilter);
    // reset to first page and reload
  setController((prev) => ({ ...prev, page: 1 }));
  categoryListAPI(newFilter); 
};


  const categoryListAPI = async (filterOverride = filter) => {
    try {
      let payload = {
        count: controller.rowsPerPage,
        page: controller.page,
        search: filterOverride.search?.trim() || null,
      };

      if (filterOverride.isDeleted === "true") payload.isDeleted = true;
      else if (filterOverride.isDeleted === "false") {
         payload.isActive = true;
         payload.isDeleted = false;
      } 

      setSpinner(true);
      let response = await CATEGORY_LIST(payload);
      setCategoryList(response?.data);
      setTotalCount(response?.totalCount || 0);
    } catch (error) {
      setCategoryList([]);
    }
    setSpinner(false);
  };

    const categoryAdd = async () => {
         if(!isValid()) return;
    try {
      let payload = {
        name: formDataCategory.name,

      };

      setSpinner(true);
      let response = await CATEGORY_ADD(payload);
      if (response.code === 200) {
        toast.success(response.message || "Category updated successfully");
        handleCloseModal();
        categoryListAPI();
        setFormDataCategory({});
      } else {
        toast.error(response.message || "Category update failed");
      }
    } catch (error) {
      setCategoryList([]);
    }
    setSpinner(false);
  };
  
  const categoryUpdate = async () => {
 if(!isValid()) return;
    try {
      let payload = {
     _id: formDataCategory._id,
      name: formDataCategory.name,
      };

      setSpinner(true);
      let response = await CATEGORY_UPDATE(payload);
      if (response.code === 200) {
        toast.success(response.message || "Category updated successfully");
        categoryListAPI();
         handleCloseModal();
        setFormDataCategory({});
      } else {
        toast.error(response.message || "Category update failed");
      }
    } catch (error) {
      categoryListAPI([]);
    }
    setSpinner(false);
  };

    const categoryDelete = async (id, isDeleted) => {
  
    try {
      let payload = {
        _id:id,
        isDeleted:!isDeleted
      };

      setSpinner(true);
      let response = await CATEGORY_DELETE(payload);
      if (response.code === 200) {
        toast.success(response.message || "Category deleted successfully");
        const newPage =
    categoryList.length === 1 && controller.page > 1
      ? controller.page - 1
      : controller.page;

  setController((prev) => ({ ...prev, page: newPage }));
        categoryListAPI();
      
      } else {
        toast.error(response.message || (isDeleted ? "Category recovered successfully" : "Category deleted successfully"));
      }
    } catch (error) {
      categoryListAPI([]);
    }
    setSpinner(false);
  };


  const categoryToggleStatusChange = async (id, isActive) => {
    try {
      const payload = {
        _id: id,
        isActive: isActive,
      };
  
      setSpinner(true);
      const response = await CATEGORY_STATUS_CHANGE(payload);
  
      if (response?.code === 200) {
        toast.success(response?.message || "Status updated successfully");
        await categoryListAPI(); // refresh updated list
      } else {
        toast.error(response?.message || "Failed to update status");
      }
    } catch (error) {
      toast.error("Something went wrong while updating vendor status");
    } finally {
      setSpinner(false);
    }
  };
  
  const handleToggleChange = (id, currentStatus) => {
    const newStatus = !currentStatus;
    categoryToggleStatusChange(id, newStatus);
  };
  
  

  return {
    data: {
      spinner,
      formDataCategory,
      formError,
      isEditMode,
      controller,
      totalCount,
      categoryList,
      openModal,
      filter,
    },
    methods: {
      handleChange,
      handleOpenModal,
      handleCloseModal,
      categoryUpdate,
      handlePagination,
      categoryAdd,
      categoryDelete,
      handleToggleChange,
             handleSearchChange,
    handleStatusChange,
    handleApplyFilter,
    handleResetFilter,
    },
  };
};

export default useCategory;
